import { render, staticRenderFns } from "./limit-extension-application-detail.vue?vue&type=template&id=9ccaa13a"
import script from "./limit-extension-application-detail.vue?vue&type=script&lang=js"
export * from "./limit-extension-application-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports